import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import {appApiResources} from '../../../configuration/app.constants';


@Injectable({
  providedIn: 'root'
})
export class LetterContentService {

  constructor(private http: HttpClient) {}

  async GeLetterContent() {
    try { 
      let response = await this.http
        .get(`https://ezekiahfrancis.org/api/letter`)
        .toPromise();
      return response;
    } catch (error) { 
      return error;
    }
  }
}
